<template>
  <section class="section" id="step-0">
    <h3>1. Vložte VIN vozu a předvyplňte údaje</h3>

    <!-- Type Selection -->
    <div class="pt-2 mb-4">
      <div class="form-check form-check-inline">
        <input
          v-model="modelType"
          class="form-check-input"
          type="radio"
          name="type"
          id="type-personal"
          value="personal"
        />
        <label class="form-check-label" for="type-personal">Osobní</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          v-model="modelType"
          class="form-check-input"
          type="radio"
          name="type"
          id="type-utility"
          value="utility"
        />
        <label class="form-check-label" for="type-utility">Užitkové</label>
      </div>
    </div>

    <!-- Fields -->
    <div class="row gx-4">
      <!-- Car State Selection -->
      <FormSelect
        id="car-state-select"
        modalId="single-car-state-modal"
        label="Stav vozu"
        :is-required="true"
        :selected-option="selectedCarState"
        css-style="col-xl-6 col-lg-6 pt-lg-2 pt-2 pb-lg-1 pb-1"
      />

      <!-- VIN Input -->
      <FormInput
        v-model="vin"
        label="VIN"
        placeholder="Zadejte 17místný VIN kód"
        :max-length="17"
        :pattern="/(?=.*\d|=.*[A-Z])(?=.*[A-Z])[A-Z0-9]{17}/"
        input-type="text"
        :is-required="true"
        masked-type="vin"
        :show-length-counter="true"
        css-style="col-xl-6 col-lg-6 pt-lg-2 pt-2 pb-lg-1 pb-1"
      />
    </div>

    <!-- Helper text -->
    <p class="mb-3 small">
      Vložením platného VIN se předvyplní údaje o voze.<br>
      <strong>VIN vozu naleznete v technickém průkazu</strong>
      (<a href="#" @click.prevent="openTechnicalDoc">ukázka</a>).
    </p>

    <!-- Load Button -->
    <div class="pt-lg-2 pt-2 pb-lg-3 pb-2">
      <button
        @click.prevent="handlePrefillFromVin"
        class="btn btn-primary btn-lg"
        :disabled="!isFormValid || isLoadingVin"
        type="button"
      >
        <span v-if="!isLoadingVin">
          Předvyplnit z VIN
        </span>
        <span v-else>
          Načítám data...
        </span>
      </button>
    </div>

  </section>
</template>

<script>
import FormInput from '../../FormInput.vue';
import VehicleDataService from '../../../services/vehicleDataService';
import FormSelect from "@/src/components/FormSelect.vue";
import technicalDocImage from '../../../../images/technicky_prukaz.jpg';

export default {
  name: 'VinPrefillStep',

  components: {
    FormSelect,
    FormInput,
  },

  data() {
    return {
      isLoadingVin: false,
    };
  },

  computed: {
    vin: {
      get() {
        return this.$store.state.AdvertisementStore.advertisement.vin || '';
      },
      set(value) {
        this.$store.commit('AdvertisementStore/vin', value);
      },
    },

    modelType: {
      get() {
        return this.$store.state.AdvertisementStore.advertisement.modelType;
      },
      set(value) {
        this.$store.commit('AdvertisementStore/modelType', value);
      },
    },

    selectedCarState: {
      get() {
        return this.$store.state.AdvertisementStore.advertisement.carState;
      },
      set(value) {
        this.$store.commit('AdvertisementStore/selectCarState', value);
      },
    },

    isFormValid() {
      return (
        this.modelType &&
        this.selectedCarState &&
        this.selectedCarState.id &&
        this.vin &&
        this.vin.length === 17
      );
    },
  },

  methods: {
    openTechnicalDoc() {
      window.openLightbox(technicalDocImage, 'Ukázka technického průkazu');
    },

    openCarStateModal() {
      this.$store.dispatch('ModalStore/openModal', {
        id: 'single-car-state-modal',
      });
    },

    async handlePrefillFromVin() {
      this.isLoadingVin = true;

      // Save VIN to store
      this.$store.commit('AdvertisementStore/vin', this.vin);

      // Fetch vehicle data with model type
      const result = await VehicleDataService.fetchByVin(this.vin, this.modelType);

      if (result.success) {
        const mappedData = VehicleDataService.mapVehicleDataToAdvertisement(result.data);
        const mutationMapping = VehicleDataService.getMutationMapping();

        let fieldsUpdated = 0;

        Object.entries(mappedData).forEach(([key, value]) => {
          const mutation = mutationMapping[key];
          if (mutation) {
            this.$store.commit(`AdvertisementStore/${mutation}`, value);
            fieldsUpdated++;
          }
        });

        this.$emit('show-notification', {
          type: 'success',
          message: `Zkontrolujte předvyplněné údaje (${fieldsUpdated}) a můžete pokračovat se zadáváním inzerátu.`,
        });

        // Move to next step
        this.$emit('prefill-complete');
      } else {
        this.$emit('show-notification', {
          type: 'error',
          message: 'Pro toto VIN nebyla nalezena žádná data. Možné důvody:',
          items: [
            'Vozidlo nebylo doposud přihlášeno v ČR.',
            'Chybný VIN kód.'
          ]
        });
        this.$emit('prefill-complete');
      }

      this.isLoadingVin = false;
    },
  },
};
</script>
